export default [
  {
    path: "/home",
    component: () => import("@/pages/Home.vue"),
  },
  {
    path: "/forbidden",
    component: () => import("@/pages/Forbidden.vue"),
  },
  {
    path: "*",
    component: () => import("@/pages/NotFound.vue"),
  },
];
